export default __webpack_public_path__ + "content/media/22.5230c2b6.jpg";